import {element, CustomElement} from "./CustomElement";
import {i18n} from "../i18n/I18n";
import {icons} from "../icons/Icons";

export function register() {
	element("flipp-rating")(RatingElement);
}

class RatingElement extends CustomElement {
	protected attributeChangedCallback(attr: string) {
		if (attr === "value")
			this._render();
	}

	get value(): number {
		const v = parseFloat(this.getAttribute("value"));
		return isNaN(v) ? 2.5 :
				Math.max(1, Math.min(Math.round(v * 2) / 2, 5));
	}

	set value(value: number) {
		this.setAttribute("value", value.toString());
	}

	private _render() {
		const value = this.value;
		const fullStars = Math.floor(value);
		const halfStars = Math.ceil(value) - fullStars;
		const emptyStars = Math.max(0, 5 - fullStars - halfStars);

		flipp.setVirtualDOM(false);
		this.setAttribute("role", "img");
		while (this.hasChildNodes())
			this.removeChild(this.firstChild);

		for (let i = 0; i < fullStars; ++i)
			this.appendChild(icons.fullStar);
		for (let i = 0; i < halfStars; ++i)
			this.appendChild(icons.halfStar);
		for (let i = 0; i < emptyStars; ++i)
			this.appendChild(icons.emptyStar);

		this.setAttribute("aria-label", i18n( "x_of_n_stars", {
			x: (fullStars + halfStars / 2).toString(),
			n: "5"
		}));
	}
}
